module.exports = __webpack_public_path__ + "static/img_devis-f062cefe954f405a93e0573113deb9f5.svg";